import styled from 'styled-components';

export const Container = styled.div`
  form {
    width: 100%;

    .buttonsContainer {
      display: flex;
      justify-content: flex-end;
    }

    label[for='numero'] {
      font-size: 18px;
    }

    .numberInput {
      height: 45px;
    }
  }
`;
